(() => {
  'use strict';
  const cfg = window.psnTheme;
  window.psnMoney = value => new Intl.NumberFormat(cfg.locale || 'es-CL', { style: 'currency', currency: cfg.currency || 'CLP' }).format(Number(value));
  window.psnAddToCart = async (id, quantity, button, buyNow = false) => {
    if (button.getAttribute('aria-busy') === 'true') return;
    const count = Number(quantity);
    if (!id || !Number.isInteger(count) || count < 1 || count > 99) return;
    const previous = button.textContent;
    button.setAttribute('aria-busy', 'true'); button.textContent = 'Agregando…';
    const container = button.closest('form, .game-purchase') || button.parentElement;
    let status = container.querySelector('[data-purchase-message]');
    if (!status) { status = document.createElement('p'); status.dataset.purchaseMessage = ''; status.setAttribute('role', 'alert'); container.append(status); }
    status.textContent = ''; status.classList.remove('theme-purchase-error');
    try {
      const response = await fetch(cfg.cartAdd, { method: 'POST', credentials: 'same-origin', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:String(id),quantity:count}]}) });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No pudimos agregar esta opción. Revisa su disponibilidad e inténtalo de nuevo.');
      window.location.assign(buyNow ? cfg.root.replace(/\/?$/, '/') + 'checkout' : cfg.cart);
    } catch(error) {
      status.textContent = error.message || 'No pudimos conectar. Inténtalo de nuevo.';
      status.classList.add('theme-purchase-error');
    } finally { button.removeAttribute('aria-busy'); button.textContent = previous; }
  };
  function initProduct(root) {
    const area = root.matches?.('[data-product-page]') ? root : root.querySelector('[data-product-page]');
    if (!area || area.dataset.initialized) return;
    const game = JSON.parse(area.querySelector('[data-product-data]').textContent);
    if (!game?.variants?.length) return;
    area.dataset.initialized = 'true';
    const picker = area.querySelector('[data-product-options]');
    const select = area.querySelector('[data-variant-select]');
    const quantity = area.querySelector('[name=quantity]');
    const button = area.querySelector('[data-product-submit]');
    const buyNow = area.querySelector('[data-product-buy-now]');
    const image = area.querySelector('[data-product-image]');
    let chosen = (game.variants.find(v => String(v.id) === select.value) || game.variants[0]).options.slice();
    function update() {
      const variant = purchaseOptions.find(game, chosen);
      const qty = Number(quantity.value);
      button.disabled = !variant?.available || !Number.isInteger(qty) || qty < 1 || qty > 99;
      buyNow.disabled = button.disabled;
      button.textContent = !variant?.available ? 'Opción no disponible' : 'Agregar al carrito';
      select.value = variant?.id || '';
      area.querySelector('[data-product-price]').textContent = variant ? window.psnMoney(variant.price) : '—';
      area.querySelector('[data-product-stock]').textContent = variant?.available ? 'Disponible para comprar' : 'Esta opción está agotada';
      const quote = purchaseOptions.quote(variant,qty);
      area.querySelector('[data-product-discount]').hidden = !quote.saving;
      area.querySelector('[data-product-compare]').textContent = window.psnMoney(quote.compareAt);
      area.querySelector('[data-product-saving]').textContent = `Ahorras ${quote.saving}%`;
      if (variant?.image) image.src = variant.image;
      picker.querySelectorAll('input').forEach(input => {
        const index = Number(input.dataset.index);
        input.checked = chosen[index] === input.value;
        input.disabled = !purchaseOptions.available(game, chosen, index, input.value);
      });
      if (variant) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
    }
    const groups = purchaseOptions.groups(game);
    if (groups.length === 1 && groups[0].values.length === 1 && groups[0].values[0] === 'Default Title') {
      area.querySelector('.native-variant').hidden = true;
    } else {
      groups.forEach(group => {
        const fieldset = document.createElement('fieldset'); fieldset.className = 'game-option-group';
        const legend = document.createElement('legend'); legend.textContent = group.label; fieldset.append(legend);
        const row = document.createElement('div'); row.className = 'game-option-buttons';
        group.values.forEach(value => {
          const label = document.createElement('label'); label.className = 'game-option';
          const input = document.createElement('input'); input.type = 'radio'; input.name = `product-option-${group.index}`; input.value = value; input.dataset.index = group.index;
          const optionLabel = purchaseOptions.label(value);
          const face = document.createElement('span'); face.textContent = optionLabel;
          label.append(input,face);
          if (group.label === 'Tipo de cuenta' && /^(Primaria|Secundaria)$/i.test(optionLabel)) {
            label.classList.add('game-option--account');
            const note = document.createElement('small');
            note.className = `account-option-note account-option-note--${/^Primaria$/i.test(optionLabel) ? 'recommended' : 'saving'}`;
            note.textContent = /^Primaria$/i.test(optionLabel) ? 'Recomendada' : 'Más económica';
            label.append(note);
          }
          row.append(label);
        }); fieldset.append(row); picker.append(fieldset);
      });
      area.querySelector('.native-variant').hidden = true;
    }
    area.querySelector('[data-account-help]').hidden = !groups.some(g => g.label === 'Tipo de cuenta');
    picker.addEventListener('change',event => { if (!event.target.matches('input')) return; chosen = purchaseOptions.choose(game,chosen,Number(event.target.dataset.index),event.target.value); update(); });
    quantity.addEventListener('input',update);
    area.querySelectorAll('[data-quantity-step]').forEach(control => control.addEventListener('click',() => { quantity.value = purchaseOptions.quantity(Number(quantity.value) + Number(control.dataset.quantityStep)); update(); }));
    area.querySelector('form').addEventListener('submit',event => { event.preventDefault(); if (!button.disabled && !area.dataset.submitting) { const active = event.submitter === buyNow ? buyNow : button; area.dataset.submitting = 'true'; button.disabled = buyNow.disabled = true; Promise.resolve(window.psnAddToCart(select.value,quantity.value,active,active === buyNow)).finally(() => { delete area.dataset.submitting; update(); }); } });
    area.querySelectorAll('[data-gallery-image]').forEach(control => control.addEventListener('click',() => {image.src=control.dataset.galleryImage;}));
    update();
  }
  initProduct(document);
  document.addEventListener('shopify:section:load',event => initProduct(event.target));
})();
